export const TRUNCATE = 150
